import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconUpgrade = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M15.5997 4.71963C15.2197 4.26365 14.6568 4 14.0633 4H9.93675C9.34319 4 8.78029 4.26365 8.40031 4.71963L5.04546 8.74545C4.43702 9.47558 4.42645 10.5331 5.02017 11.2752L10.4383 18.0478C11.2389 19.0486 12.7611 19.0486 13.5617 18.0478L18.9798 11.2752C19.5736 10.5331 19.563 9.47558 18.9545 8.74545L15.5997 4.71963ZM9.94 6H14.07L16.57 9H7.44L9.94 6ZM7.36 11H16.64L12 16.8L7.36 11Z" />
      </svg>
    );
  }
);
